import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import './ResourceListAsPerAccessionNumber.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import LibraryApiCall from 'LibraryApiCall';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import AdvanceFilterIcon from "LIBRARY/CommonResources/images/advanceFilterIcon.png";
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import filterIcon from 'LIBRARY/CommonResources/images/filterIcon.svg';


let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];


class ResourceListAsPerAccessionNumber extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All resource list as per accession series
            resourceListLoading: false,
            totalResourceListItems: 0,
            resourceList: {},
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByTitle: '',
            searchByAuthor: '',
            searchByAccessionNumber: '',
            searchByInvoiceNumber: [],
            searchByAccessionSeries: [],
            searchByDepartment: [],
            searchByResourceCategory: [],
            searchByLocation: [],
            searchByResourceType: [],
            searchByResourceStatus: {
                "value": "available",
                "label": "available"
            },
            isDonated: false,
            notIssuedResource: false,
            searchByPublisher: '',
            searchAccessionNumberFrom: '',
            searchAccessionNumberTo: '',
            searchMultipleAccessionNumber: [],
            searchAccessionNo: '',

            GetInvoiceDataList: {},
            loadingInvoiceData: false,
            accessionSeriesList: {},
            loadingAccessionSeries: false,
            GetStreamList: {},
            loadingStreamData: false,
            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,
            GetLocationList: {},
            loadingLocationData: false,
            GetResourceStatusList: {},
            loadingResourceStatusData: false,
            GetPublisherList: {},
            loadingPublisherData: false,
            GetMultipleAccessionNumberList: {},
            loadingAccessionNumberData: false,

            //filter button 
            showFilterModal: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Accession Series", isVisible: true },
                { name: 'Accession Number', isVisible: true },
                { name: 'Accession Date', isVisible: true },
                { name: "Call Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Resource Volume", isVisible: true },
                { name: "Resource Edition", isVisible: true },
                { name: "Resource Language", isVisible: true },
                { name: "Publisher", isVisible: true },
                { name: "Publisher City", isVisible: true },
                { name: "Number of Pages", isVisible: true },
                { name: "Number of Preliminary Pages", isVisible: true },
                { name: 'Resource Category', isVisible: true },
                { name: 'Sub Category', isVisible: true },

                { name: "Year of Publication", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Translator Name", isVisible: true },
                { name: "Translated", isVisible: true },
                { name: "Search Keyword", isVisible: true },
                { name: "Location", isVisible: true },
                { name: "ISBN Number", isVisible: true },
                { name: "Resource Condition", isVisible: true },
                { name: 'Vendor Name', isVisible: true },
                { name: 'Vendor City', isVisible: true },
                { name: 'Vendor Country', isVisible: true },
                { name: 'Invoice/Bill No.', isVisible: true },
                { name: "Invoice/Bill Date", isVisible: true },
                { name: "Price", isVisible: true },

                { name: "Discounted Amount", isVisible: true },
                { name: "Net Price", isVisible: true },
                { name: "Donated", isVisible: true },
                { name: "Resource Status", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Accession Series", key: 'accessionSeries' },
                { name: 'Accession Number', key: 'accessionNumber' },
                { name: 'Accession Date', key: 'accessionDate' },
                { name: "Call Number", key: 'callNumber' },
                { name: "Title", key: 'title' },
                { name: "Author", key: 'author' },
                { name: "Resource Volume", key: 'resourceVolume' },
                { name: "Resource Edition", key: 'resourceEdition' },
                { name: "Resource Language", key: 'resourceLanguage' },
                { name: "Publisher", key: 'publisher' },
                { name: "Publisher City", key: 'publisherCity' },
                { name: "Number of Pages", key: 'numberOfPages' },
                { name: "Number of Preliminary Pages", key: 'numberOfPreliminaryPages' },
                { name: 'Resource Category', key: 'resourceCategory' },
                { name: 'Sub Category', key: 'subCategory' },

                { name: "Year of Publication", key: 'yearOfPublication' },
                { name: "Department", key: 'department' },
                { name: "Resource Type", key: 'resourceType' },
                { name: "Translator Name", key: 'translatorName' },
                { name: "Translated", key: 'translated' },
                { name: "Search Keyword", key: 'searchKeyword' },
                { name: "Location", key: 'location' },
                { name: "ISBN Number", key: 'isbnNumber' },
                { name: "Resource Condition", key: 'resourceCondition' },
                { name: 'Vendor Name', key: 'venderName' },
                { name: 'Vendor City', key: 'vendorCity' },
                { name: 'Vendor Country', key: 'vendorCountry' },
                { name: 'Invoice/Bill No.', key: 'invoiceNumber' },
                { name: "Invoice/Bill Date", key: 'invoiceDate' },
                { name: "Price", key: 'price' },

                { name: "Discounted Amount", key: 'discountedAmount' },
                { name: "Net Price", key: 'netPrice' },
                { name: "Donated", key: 'donated' },
                { name: "Resource Status", key: 'resourceStatus' }
            ],

            exportItemVisibility: [
                { name: "Accession Series", isVisible: true },
                { name: 'Accession Number', isVisible: true },
                { name: 'Accession Date', isVisible: true },
                { name: "Call Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Resource Volume", isVisible: true },
                { name: "Resource Edition", isVisible: true },
                { name: "Resource Language", isVisible: true },
                { name: "Publisher", isVisible: true },
                { name: "Publisher City", key: 'publisherCity' },
                { name: "Number of Pages", isVisible: true },
                { name: "Number of Preliminary Pages", isVisible: true },
                { name: 'Resource Category', isVisible: true },
                { name: 'Sub Category', isVisible: true },

                { name: "Year of Publication", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Translator Name", isVisible: true },
                { name: "Translated", isVisible: true },
                { name: "Search Keyword", isVisible: true },
                { name: "Location", isVisible: true },
                { name: "ISBN Number", isVisible: true },
                { name: "Resource Condition", isVisible: true },
                { name: 'Vendor Name', isVisible: true },
                { name: 'Vendor City', key: 'vendorCity' },
                { name: 'Vendor Country', key: 'vendorCountry' },
                { name: 'Invoice/Bill No.', isVisible: true },
                { name: "Invoice/Bill Date", isVisible: true },
                { name: "Price", isVisible: true },

                { name: "Discounted Amount", isVisible: true },
                { name: "Net Price", isVisible: true },
                { name: "Donated", isVisible: true },
                { name: "Resource Status", isVisible: true }
            ],

            //STATE FOR ORDER BY
            orderByResources: [
                { name: "Accession Number By Ascending", value: 'orderByAccessionNoAsce' },
                { name: "Accession Number By Descending", value: 'orderByAccessionNoDesc' },
                { name: "Highest Issued Resources", value: 'orderByMostIssuedAsec' },
                { name: "Lowest Issued Resources", value: 'orderByMostIssuedDesc' }
            ],

            isOrderByResourcesValue: 'orderByAccessionNoAsce',

            // export all
            isExportAllReportDataFetching: false,
            allReportData: [],
            allSortedIdArray: [],
            sortedIdArray: [],

            // grand total count
            priceTotal: 0,
            discountTotal: 0,
            grandTotal: 0,

            // total count
            priceTotalCount: 0,
            discountTotalCount: 0,
            netPriceTotalCount: 0,

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        this.GetLibraryResourceListForReport();  // report list
        this.getLibraryInvoiceListDataStatus();  // invoice data
        this.apiCallToGetAccessionSeries(); // accession series
        this.apiCallToGetInstituteStreamList();  // department
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.GetLibraryLocationList();  // location list
        this.getLibraryResourceStatus();  // resource status
        this.getPublisherList();  // publisher list
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF REPORT
    GetLibraryResourceListForReport = async () => {
        this.setState({
            resourceListLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'resource_status': 'all',
            'orderBy': this.state.isOrderByResourcesValue
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceListForReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceListForReport()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        // Use reduce to accumulate totals
                        const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                            const keyDiscount = resource.discount || 0;
                            const keyPrice = resource.price || 0;

                            // Calculate net amount
                            const netAmount = (parseInt(keyPrice) - ((parseInt(keyPrice) * parseInt(keyDiscount)) / 100)) || 0;

                            // Accumulate totals
                            accumulator.totalPrice += parseInt(keyPrice);
                            accumulator.totalDiscount += ((parseInt(keyPrice) * parseInt(keyDiscount)) / 100);
                            accumulator.totalNetPrice += netAmount;

                            return accumulator;
                        }, {
                            totalPrice: 0,
                            totalDiscount: 0,
                            totalNetPrice: 0
                        });

                        this.setState({
                            resourceList: apiResult.data,
                            totalResourceListItems: apiResult?.resource_count,
                            priceTotal: apiResult?.priceTotal,
                            discountTotal: apiResult?.discountTotal,
                            grandTotal: apiResult?.grandTotal,
                            priceTotalCount: totals.totalPrice,
                            discountTotalCount: totals.totalDiscount,
                            netPriceTotalCount: totals.totalNetPrice,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceList: {},
                            totalResourceListItems: 0,
                            priceTotal: 0,
                            discountTotal: 0,
                            grandTotal: 0,
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceList: {},
                        totalResourceListItems: 0,
                        resourceListLoading: false
                    });
                }
            }
        }
    }

    // API CALL TO GET get invoice List 
    getLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingInvoiceData: true,
        })
        let requestData = {
            iid: config.institute_id,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.billno, // Display billno
                }));

                this.setState({
                    GetInvoiceDataList: formattedData,
                    loadingInvoiceData: false,
                })
            } else {
                this.setState({
                    loadingInvoiceData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeries: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesData.seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeries: false
                });
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })
        let requestData = {
            iid: config.institute_id,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // API CALL TO GET get location List 
    GetLibraryLocationList = async () => {
        this.setState({
            loadingLocationData: true,
        })
        let requestData = {
            iid: config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    GetLocationList: formattedData,
                    loadingLocationData: false,
                })
            } else {
                this.setState({
                    loadingLocationData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource status List 
    getLibraryResourceStatus = async () => {
        this.setState({
            loadingResourceStatusData: true,
        })
        let requestData = {
            "iid": config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryResourceStatus',
            requestData,
            "/api/library/libraryResourceStatus.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryResourceStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetResourceStatusList: apiResult.data,
                    loadingResourceStatusData: false,
                })
            } else {
                this.setState({
                    loadingResourceStatusData: false,
                })
            }
        }
    }

    // API CALL TO GET get publisher List 
    getPublisherList = async () => {
        this.setState({
            loadingPublisherData: true,
        })
        let requestData = {
            iid: config.institute_id,
            isOrderByAscendingDisplayName: "true",
            pageIndex: "all",
            limitPerPage: "all"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getPublisherList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPublisherList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                // const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                //     value: seriesId,
                //     name: seriesData?.name,
                // }));

                this.setState({
                    GetPublisherList: apiResult.data,
                    loadingPublisherData: false,
                })
            } else {
                this.setState({
                    loadingPublisherData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET MULTIPLE ACCESSION NUMBER
    getMultipleAccessionNoList = async () => {
        this.setState({ loadingAccessionNumberData: true });

        let accessionSeriesIdArray = []
        this.state.searchByAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })


        let requestData = {
            "iid": config.institute_id,
            "accessionSeriesIdArr": accessionSeriesIdArray,
            "searchAccssionSeriesNo": this.state.searchAccessionNo,
            "pageIndex": 1,
            "limitPerPage": 10
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getMultipleAccessionNumber',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getMultipleAccessionNoList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                const formattedMembers = Object.values(apiResult).map((data) => ({
                    value: data.resourceId,
                    label: data?.accessionNo,
                }));

                this.setState({
                    GetMultipleAccessionNumberList: formattedMembers,
                    loadingAccessionNumberData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionNumberData: false
                });
            }
        }
    }

    // filtered list
    GetFilteredLibraryResourceList = async () => {
        this.setState({
            resourceListLoading: true
        });

        let invoiceNumberArray = [];
        let accessionSeriesIdArray = [];
        let departmentIdArray = [];
        let categoryIdArray = [];
        let locationIdArray = [];
        let typeNameArray = [];
        let publisherValue = this.state.searchByPublisher ? Object.values(this.state.searchByPublisher)[0] : ''
        let multipleAccessionNo = [];

        this.state.searchByAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })

        this.state.searchByDepartment?.map((item) => {
            departmentIdArray.push(item.value)
        })

        this.state.searchByResourceCategory?.map((item) => {
            categoryIdArray.push(item.value)
        })

        this.state.searchByLocation?.map((item) => {
            locationIdArray.push(item.value)
        })

        this.state.searchByResourceType?.map((item) => {
            typeNameArray.push(item.value)
        })

        this.state.searchByInvoiceNumber?.map((item) => {
            invoiceNumberArray.push(item.value)
        })

        this.state.searchMultipleAccessionNumber?.map((item) => {
            multipleAccessionNo.push(item.value)
        })

        let searchTitleValue = this.state.searchByTitle || "";
        let searchAuthorValue = this.state.searchByAuthor || "";
        let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
        let searchInvoiceNumberValue = invoiceNumberArray;
        let searchAccessionSeriesValue = accessionSeriesIdArray;
        let searchDepartmentValue = departmentIdArray;
        let searchCategoryValue = categoryIdArray;
        let searchLocationValue = locationIdArray;
        let searchTypeValue = typeNameArray;
        let searchStatusValue = Object.values(this.state.searchByResourceStatus)[0];
        let searchMultipleAccessionNumberValue = multipleAccessionNo;

        let filterParameter = {
            "searchTitle": searchTitleValue,
            "searchAccessionNumber": searchAccessionNumberValue,
            "searchAuthor": searchAuthorValue,
            "resource_status": searchStatusValue,
            // "searchAccessionNumberFrom": [],
            // "searchAccessionNumberTo": [],
            "searchinvoice": searchInvoiceNumberValue,
            "searchseries": searchAccessionSeriesValue,
            "streams": searchDepartmentValue,
            "searchresourcecategory": searchCategoryValue,
            "searchlocation": searchLocationValue,
            "searchType": searchTypeValue,
            "notIssuedResource": this.state.notIssuedResource,
            "searchAccessionNumberFrom": this.state.searchAccessionNumberFrom,
            "searchAccessionNumberTo": this.state.searchAccessionNumberTo,
            "publisher": publisherValue,
            "searchMultipleAccessionNumber": searchMultipleAccessionNumberValue,
            'orderBy': this.state.isOrderByResourcesValue,
            ...(this.state.isDonated ? { "resource_donation_status": "donated" } : {}) // Conditionally add the "resource_donation_status" field
        };


        let requestData = {
            iid: config.institute_id,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            filterParameter: filterParameter
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetFilteredLibraryResourceListForReport",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFilteredLibraryResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                // Use reduce to accumulate totals
                const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                    const keyDiscount = resource.discount || 0;
                    const keyPrice = resource.price || 0;

                    // Calculate net amount
                    const netAmount = (parseInt(keyPrice) - ((parseInt(keyPrice) * parseInt(keyDiscount)) / 100)) || 0;

                    // Accumulate totals
                    accumulator.totalPrice += parseInt(keyPrice);
                    accumulator.totalDiscount += ((parseInt(keyPrice) * parseInt(keyDiscount)) / 100);
                    accumulator.totalNetPrice += netAmount;

                    return accumulator;
                }, {
                    totalPrice: 0,
                    totalDiscount: 0,
                    totalNetPrice: 0
                });

                this.setState({
                    resourceList: apiResult.data,
                    totalResourceListItems: apiResult?.resource_count,
                    grandTotal: apiResult?.grandTotal,
                    priceTotalCount: totals.totalPrice,
                    discountTotalCount: totals.totalDiscount,
                    netPriceTotalCount: totals.totalNetPrice,
                    resourceListLoading: false
                });
            }
        }
    };

    // filter title on change
    handleTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByTitle: event.target.value });
    };
    handleResourceTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // filter author on change
    handleFilterAuthorChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAuthor: event.target.value });
    };
    handleResourceAuthorKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // filter Accession Number on change
    handleFilterAccessionNoChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAccessionNumber: event.target.value });
    };
    handleResourceAccessionNoKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // filter Accession Number from on change
    handleFilterAccessionNoFromChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchAccessionNumberFrom: event.target.value });
    };

    // filter Accession Number to on change
    handleFilterAccessionNoToChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchAccessionNumberTo: event.target.value });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        if (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'available' || this.state.notIssuedResource != false || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber.length !== 0 || this.state.searchByPublisher !== '') {
            this.setState({
                pageIndex: 1, limit: event.target.value, searchByTitle: this.state.searchByTitle, searchByAuthor: this.state.searchByAuthor, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByInvoiceNumber: this.state.searchByInvoiceNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByLocation: this.state.searchByLocation, searchByResourceType: this.state.searchByResourceType, isDonated: this.state.isDonated, searchByResourceStatus: this.state.searchByResourceStatus, notIssuedResource: this.state.notIssuedResource, searchAccessionNumberFrom: this.state.searchAccessionNumberFrom, searchAccessionNumberTo: this.state.searchAccessionNumberTo, publisher: this.state.publisher, "searchMultipleAccessionNumber": this.state.searchMultipleAccessionNumber,
            }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ pageIndex: 1, limit: event.target.value }, () => {
                this.GetLibraryResourceListForReport();
            });
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        if (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'available' || this.state.notIssuedResource != false || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber.length !== 0 || this.state.searchByPublisher !== '') {
            this.setState({ pageIndex: pageNumber, searchByTitle: this.state.searchByTitle, searchByAuthor: this.state.searchByAuthor, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByInvoiceNumber: this.state.searchByInvoiceNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByLocation: this.state.searchByLocation, searchByResourceType: this.state.searchByResourceType, isDonated: this.state.isDonated, searchByResourceStatus: this.state.searchByResourceStatus, notIssuedResource: this.state.notIssuedResource, searchAccessionNumberFrom: this.state.searchAccessionNumberFrom, searchAccessionNumberTo: this.state.searchAccessionNumberTo, publisher: this.state.publisher, "searchMultipleAccessionNumber": this.state.searchMultipleAccessionNumber, }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ pageIndex: pageNumber }, () => {
                this.GetLibraryResourceListForReport();
            });
        }
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByTitle: '', searchByAuthor: '', searchByAccessionNumber: '', searchByInvoiceNumber: [], searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByLocation: [], searchByResourceType: [], searchByResourceStatus: {
                "value": "available",
                "label": "available"
            }, isDonated: false, notIssuedResource: false, searchByPublisher: '', searchAccessionNumberFrom: '', searchAccessionNumberTo: '', searchMultipleAccessionNumber: [],
            limit: "10", pageIndex: 1
        }
            , () => {
                this.GetLibraryResourceListForReport();
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterResourceTitle = this.state.searchByTitle
        let filterResourceAuthor = this.state.searchByAuthor
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterInvoiceNumber = this.state.searchByInvoiceNumber
        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterLocation = this.state.searchByLocation
        let filterResourceType = this.state.searchByResourceType
        let filterResourceStatus = this.state.searchByResourceStatus
        let filterIsDonated = this.state.isDonated
        let filterNotIssuedResource = this.state.notIssuedResource
        let filterAccessionNoFrom = this.state.searchAccessionNumberFrom
        let filterAccessionNoTo = this.state.searchAccessionNumberTo
        let filterPublisher = this.state.searchByPublisher.label
        let filterMultipleAccessionNo = this.state.searchMultipleAccessionNumber

        if (filterResourceTitle) {
            FilterArray.push(`Resource Title - ${filterResourceTitle}`)
        }
        if (filterResourceAuthor) {
            FilterArray.push(`Resource Author - ${filterResourceAuthor}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }
        if (this.state.searchByInvoiceNumber && filterInvoiceNumber.length > 0) {
            FilterArray.push(`Invoice Number - ${filterInvoiceNumber?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.filterLocation && filterLocation.length > 0) {
            FilterArray.push(`Location - ${filterLocation?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceStatus && filterResourceStatus.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceStatus?.map(item => item.label).join(", ")}`)
        }
        if (filterIsDonated) {
            FilterArray.push(`Donated Resources - ${this.state.isDonated ? 'Donated' : 'Not-Donated'}`)
        }
        if (filterNotIssuedResource) {
            FilterArray.push(`Not Issued Resource - ${this.state.notIssuedResource ? 'Donated' : ''}`)
        }
        if (filterAccessionNoFrom) {
            FilterArray.push(`Accession Number From - ${filterAccessionNoFrom}`)
        }
        if (filterAccessionNoTo) {
            FilterArray.push(`Accession Number To - ${filterAccessionNoTo}`)
        }
        if (filterPublisher) {
            FilterArray.push(`Publisher - ${filterPublisher}`)
        }
        if (this.state.searchMultipleAccessionNumber && filterMultipleAccessionNo.length > 0) {
            FilterArray.push(`Multiple Accession Number - ${filterMultipleAccessionNo?.map(item => item.label).join(", ")}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllResourceLisAsPerAccessionNumberReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="33" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="33" style={{ textAlign: 'center' }}>
                                Resource List As Per Accession Number Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="33" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="33" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="33" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Accession Series</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Accession Number</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Date</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Call Number</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Author</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Resource Volume</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Resource Edition</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Resource Language</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Publisher</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Publisher City</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Number of Pages</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Number of Preliminary Pages</th>}
                        {this.state.exportItemVisibilityForRows[13].isVisible && <th>Resource Category</th>}
                        {this.state.exportItemVisibilityForRows[14].isVisible && <th>Sub Category</th>}
                        {this.state.exportItemVisibilityForRows[15].isVisible && <th>Year of Publication</th>}
                        {this.state.exportItemVisibilityForRows[16].isVisible && <th>Department</th>}
                        {this.state.exportItemVisibilityForRows[17].isVisible && <th>Resource Type</th>}
                        {this.state.exportItemVisibilityForRows[18].isVisible && <th>Translator Name</th>}
                        {this.state.exportItemVisibilityForRows[19].isVisible && <th>Translated</th>}
                        {this.state.exportItemVisibilityForRows[20].isVisible && <th>Search Keyword</th>}
                        {this.state.exportItemVisibilityForRows[21].isVisible && <th>Location</th>}
                        {this.state.exportItemVisibilityForRows[22].isVisible && <th>ISBN Number</th>}
                        {this.state.exportItemVisibilityForRows[23].isVisible && <th>Resource Condition</th>}
                        {this.state.exportItemVisibilityForRows[24].isVisible && <th>Vendor Name</th>}
                        {this.state.exportItemVisibilityForRows[25].isVisible && <th>Vendor City</th>}
                        {this.state.exportItemVisibilityForRows[26].isVisible && <th>Vendor Country</th>}
                        {this.state.exportItemVisibilityForRows[27].isVisible && <th>Invoice/Bill No.</th>}
                        {this.state.exportItemVisibilityForRows[28].isVisible && <th>Invoice/Bill Date</th>}
                        {this.state.exportItemVisibilityForRows[29].isVisible && <th>Price</th>}
                        {this.state.exportItemVisibilityForRows[30].isVisible && <th>Discounted Amount</th>}
                        {this.state.exportItemVisibilityForRows[31].isVisible && <th>Net Price</th>}
                        {this.state.exportItemVisibilityForRows[32].isVisible && <th>Donated</th>}
                        {this.state.exportItemVisibilityForRows[33].isVisible && <th>Resource Status</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="33">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.AccessionText || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.accession_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.callNumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.volume || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.edition || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.resource_lang || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.publisherName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.publisherCityName || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.number_of_pages || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.preliminary_pages || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.resourceCategoryName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.resourceSubCategories || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.yearOfPublication || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[16].isVisible && <td>{resource?.stream_name || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[17].isVisible && <td>{resource?.resource_type || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[18].isVisible && <td>{resource?.translator || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[19].isVisible && <td>{resource?.transalated || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[20].isVisible && <td>{resource?.search_key_word || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[21].isVisible && <td>{resource?.locationName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[22].isVisible && <td>{resource?.isbn_number || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[23].isVisible && <td>{resource?.resource_condition || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[24].isVisible && <td>{resource?.vendorName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[25].isVisible && <td>{resource?.vendorCityName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[26].isVisible && <td>{resource?.vendorCountryName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[27].isVisible && <td>{resource?.billno || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[28].isVisible && <td>{resource?.billDate || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[29].isVisible && <td>{resource?.price || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[30].isVisible && <td>{((parseInt(resource?.price) * parseInt(resource?.discount)) / 100) || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[31].isVisible && <td>{(parseInt(resource?.price) - ((parseInt(resource?.price) * parseInt(resource?.discount)) / 100)) || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[32].isVisible && <td>{resource?.donated || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[33].isVisible && <td>{resource?.resource_status || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="33">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalResourceListItems } = this.state;
        const totalPages = Math.ceil(totalResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let jsonResponse;

            let invoiceNumberArray = [];
            let accessionSeriesIdArray = [];
            let departmentIdArray = [];
            let categoryIdArray = [];
            let locationIdArray = [];
            let typeNameArray = [];
            let publisherValue = this.state.searchByPublisher ? Object.values(this.state.searchByPublisher)[0] : ''

            this.state.searchByAccessionSeries?.map((item) => {
                accessionSeriesIdArray.push(item.value)
            })

            this.state.searchByDepartment?.map((item) => {
                departmentIdArray.push(item.value)
            })

            this.state.searchByResourceCategory?.map((item) => {
                categoryIdArray.push(item.value)
            })

            this.state.searchByLocation?.map((item) => {
                locationIdArray.push(item.value)
            })

            this.state.searchByResourceType?.map((item) => {
                typeNameArray.push(item.value)
            })

            this.state.searchByInvoiceNumber?.map((item) => {
                invoiceNumberArray.push(item.value)
            })

            let searchTitleValue = this.state.searchByTitle || "";
            let searchAuthorValue = this.state.searchByAuthor || "";
            let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
            let searchInvoiceNumberValue = invoiceNumberArray;
            let searchAccessionSeriesValue = accessionSeriesIdArray;
            let searchDepartmentValue = departmentIdArray;
            let searchCategoryValue = categoryIdArray;
            let searchLocationValue = locationIdArray;
            let searchTypeValue = typeNameArray;
            let searchStatusValue = Object.values(this.state.searchByResourceStatus)[0];

            let filterParameter = {
                "searchTitle": searchTitleValue,
                "searchAccessionNumber": searchAccessionNumberValue,
                "searchAuthor": searchAuthorValue,
                "resource_status": searchStatusValue,
                "searchAccessionNumberFrom": [],
                "searchAccessionNumberTo": [],
                "searchinvoice": searchInvoiceNumberValue,
                "searchseries": searchAccessionSeriesValue,
                "streams": searchDepartmentValue,
                "searchresourcecategory": searchCategoryValue,
                "searchlocation": searchLocationValue,
                "searchType": searchTypeValue,
                "notIssuedResource": this.state.notIssuedResource,
                "searchAccessionNumberFrom": this.state.searchAccessionNumberFrom,
                "searchAccessionNumberTo": this.state.searchAccessionNumberTo,
                "publisher": publisherValue,
                ...(this.state.isDonated ? { "resource_donation_status": "donated" } : {}) // Conditionally add the "resource_donation_status" field
            };


            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'filterParameter': filterParameter
            };

            let requestListDara = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'resource_status': 'all',
                'orderBy': this.state.isOrderByResourcesValue
            }

            {
                (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'available' || this.state.notIssuedResource != false || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber.length !== 0 || this.state.searchByPublisher !== '') ?
                    jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetFilteredLibraryResourceListForReport',
                        requestData,
                        '/api/library/instructor.php'
                    ) :
                    jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetLibraryResourceListForReport',
                        requestListDara,
                        '/api/library/instructor.php'
                    )
            }

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let Data = [];
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    // this.setState(prevState =>({
                    //     // allReportData: { ...allReportData, ...apiResult },
                    //     allReportData: { ...prevState.allReportData, ...apiResult },
                    //     // allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                    //     allSortedIdArray: [...prevState.allSortedIdArray, ...sortedResponseArrayFromApi],
                    //     totalRecords: jsonResponse.APIResult.resource_count,
                    // }), () => {

                    //     // Fetch the next page recursively
                    //     this.methodToExportReportData(pageIndex);
                    // });
                    apiResult.forEach(item => {
                        Data.push(item);

                    });
                    this.setState((prevState) => ({
                        allReportData: [
                            ...prevState.allReportData,
                            ...Data,
                        ],
                    }), () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div style={{ display: this.state.advanceFilterModal ? 'flex' : 'none' }} id="reportsSideMenu">
                <div id="reportDataContainer">
                    {/* <div className="modal-content modalBulkContent"> */}
                    {/* Modal Header */}
                    <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                        <h6 className="modal-title">
                            {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px', color: '#fff' }} /> */}
                            <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                            Advanced Filter
                        </h6>
                        <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ advanceFilterModal: false }) }} style={{ cursor: "pointer" }} />
                    </div>

                    {/* Modal Content */}
                    {/* className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }} */}
                    <div className='col-md-12 pt-2 pb-3'>
                        {/* Form Group: Accession Series and multiple accession number*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={this.state.accessionSeriesList}
                                        value={this.state.searchByAccessionSeries}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 accession series', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByAccessionSeries: event || [], // Handle empty selection
                                                searchMultipleAccessionNumber: [],
                                                searchAccessionNumberFrom: '', searchAccessionNumberTo: ''
                                            }, () => {
                                                this.getMultipleAccessionNoList();  // multiple accession number list
                                            });
                                            // }
                                        }}
                                        placeholder="Select Accession Series"
                                        isLoading={this.state.loadingAccessionSeries} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Multiple Accession Number</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={this.state.GetMultipleAccessionNumberList}
                                        value={this.state.searchMultipleAccessionNumber}
                                        className="basic-multi-select-filter"
                                        isDisabled={!this.state.searchByAccessionSeries || this.state.searchByAccessionSeries.length === 0} // Disable if searchByAccessionSeries is empty
                                        onChange={(event) => {
                                            this.setState({
                                                searchMultipleAccessionNumber: event || [], // Handle empty selection
                                            });
                                        }}
                                        onInputChange={(inputValue) => {
                                            this.setState({ searchAccessionNo: inputValue }, () => {
                                                this.getMultipleAccessionNoList(); // Trigger the API call after updating the search term
                                            }, 200);
                                        }}
                                        placeholder="Select Accession Number"
                                        isLoading={this.state.loadingAccessionSeries} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                    />
                                </div>
                                <p className="d-flex justify-content-end" style={{ color: '#7A7A7A', fontSize: '12px' }}>Select/Search accession series to get multiple accession number data.</p>
                            </div>
                        </div>

                        {/* Form Group: accession number from and accession number to */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Accession Number From</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <img
                                        src={searchPng}
                                        style={{
                                            position: 'absolute',
                                            left: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#ccc',
                                            backgroundColor: 'white',
                                            width: '15px',
                                            height: '15px',
                                            zIndex: 1,
                                        }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Search by Accession Number From"
                                        style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                        value={this.state.searchAccessionNumberFrom} // Bind value to state
                                        onChange={this.handleFilterAccessionNoFromChange} // Handle input changes
                                        disabled={!this.state.searchByAccessionSeries || this.state.searchByAccessionSeries.length === 0} // Disable when empty or falsy
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>Select accession series to enter accession no from data.</p>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Accession Number To</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <img
                                        src={searchPng}
                                        style={{
                                            position: 'absolute',
                                            left: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#ccc',
                                            backgroundColor: 'white',
                                            width: '15px',
                                            height: '15px',
                                            zIndex: 1,
                                        }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByAuthorFilter"
                                        placeholder="Search by Accession Number To"
                                        style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                        value={this.state.searchAccessionNumberTo} // Bind value to state
                                        onChange={this.handleFilterAccessionNoToChange} // Handle input changes
                                        disabled={!this.state.searchByAccessionSeries || this.state.searchByAccessionSeries.length === 0} // Disable when empty or falsy
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>Select accession series to enter accession no to data.</p>
                            </div>
                        </div>

                        {/* Form Group: Publisher and Department */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Publisher</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={Object.entries(this.state.GetPublisherList).map(([seriesId, seriesData]) => ({
                                            value: seriesId,
                                            label: seriesData?.name,
                                        }))}
                                        value={this.state.searchByPublisher}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByPublisher: event || [], // Handle empty selection
                                            });

                                        }}
                                        placeholder="Select Publisher"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Department</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.searchByDepartment}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 department', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByDepartment: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Department"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Category and Location */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Category</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetResourceCategoryList).flatMap(item => {
                                            // Start with the category itself
                                            const categoryOption = {
                                                value: item.value,
                                                label: item.name,
                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                            };

                                            // If the category has subcategories, add those as well
                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                value: subCategory.subCategoryId,
                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the category option followed by the subcategory options
                                            return [categoryOption, ...subCategoryOptions];
                                        })}
                                        value={this.state.searchByResourceCategory}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 resource category', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByResourceCategory: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Resource Category"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Location</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetLocationList)?.flatMap((data) => {
                                            // Start with the parent location itself
                                            const locationOption = {
                                                value: data.value,
                                                label: data.name,
                                                isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
                                            };

                                            // If the location has sublocations, add them as well
                                            const subLocationOptions = data.sublocations?.map((sublocation) => ({
                                                value: sublocation.sublocationId,
                                                label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the location option followed by the sublocation options
                                            return [locationOption, ...subLocationOptions];
                                        })}
                                        value={this.state.searchByLocation}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 location', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByLocation: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Location"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Resource Type and  Resource Status*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Type</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.searchByResourceType}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 resource type', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByResourceType: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Resource Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Status</label>
                                <Select
                                    options={Object.values(this.state.GetResourceStatusList).map(item => ({
                                        value: item.status,
                                        label: item.status,
                                    }))}
                                    value={this.state.searchByResourceStatus}
                                    onChange={(event) => {
                                        // if (event.length > 5) {
                                        //     toast.warn('You can only select up to 5 resource status', {
                                        //         position: "top-right",
                                        //         autoClose: 2000,
                                        //         hideProgressBar: false,
                                        //         closeOnClick: true,
                                        //         pauseOnHover: true,
                                        //         draggable: true,
                                        //         progress: undefined,
                                        //     });
                                        // } else {
                                        this.setState({
                                            searchByResourceStatus: event || [], // Handle empty selection
                                        });
                                        // }
                                    }}
                                    placeholder="Select Resource Status"
                                    isLoading={this.state.loadingResourceStatusData} // Show loading spinner while fetching
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: 42, // Minimum height for the control area
                                            height: 'auto', // Allow control to grow dynamically
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: '400',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={() => (this.state.loadingResourceStatusData ? "Loading..." : "No options found")}
                                />
                            </div>
                        </div>

                        {/* Form Group: Only Donated Resources and not issued resource */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body5" color='#454E52'>
                                    <input
                                        type="checkbox"
                                        checked={this.state.isDonated}
                                        onChange={() => {
                                            // Toggle the value of isDonated
                                            this.setState(prevState => ({
                                                pageIndex: 1,  // Resetting pageIndex to 1
                                                limit: "10",    // Resetting limit to 10
                                                isDonated: !prevState.isDonated // Toggle the isDonated state
                                            }))
                                        }}
                                        style={{ marginRight: '10px' }}  // Adding space between the checkbox and text
                                    />
                                    Donated Resources
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body5" color='#454E52'>
                                    <input
                                        type="checkbox"
                                        checked={this.state.notIssuedResource}
                                        onChange={() => {
                                            // Toggle the value of notIssuedResource
                                            this.setState(prevState => ({
                                                pageIndex: 1,  // Resetting pageIndex to 1
                                                limit: "10",    // Resetting limit to 10
                                                notIssuedResource: !prevState.notIssuedResource // Toggle the notIssuedResource state
                                            }))
                                        }}
                                        style={{ marginRight: '10px' }}  // Adding space between the checkbox and text
                                    />
                                    Not Issued Resource
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer" style={{ padding: '20px 25px' }}>
                        <button
                            className="btn custom-btn"
                            style={{ fontSize: '14px', borderRadius: '7px' }}
                            // borderColor: '#0465AC !important'
                            onClick={() => {

                                this.setState({
                                    advanceFilterModal: false, searchByTitle: '', searchByAuthor: '', searchByAccessionNumber: '', searchByInvoiceNumber: [], searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByLocation: [], searchByResourceType: [], searchByResourceStatus: {
                                        "value": "available",
                                        "label": "available"
                                    }, isDonated: false, notIssuedResource: false, searchByPublisher: '', searchAccessionNumberFrom: '', searchAccessionNumberTo: '', searchMultipleAccessionNumber: [],
                                    limit: "10", pageIndex: 1
                                }, () => {
                                    this.GetLibraryResourceListForReport();
                                    this.apiCallToGetAccessionSeries(); // accession series
                                    this.GetLibraryLocationList();  // location list
                                    this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                    this.getLibraryResourceStatus();  // resource status
                                    this.getLibraryInvoiceListDataStatus();  // invoice data
                                    this.apiCallToGetInstituteStreamList(); // stream (department)
                                })
                            }}
                        >
                            Clear
                        </button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                            this.setState({ advanceFilterModal: false }, () => {
                                this.GetFilteredLibraryResourceList();
                            })
                        }}>
                            Apply
                        </button>
                    </div>
                    {/* </div> */}
                </div>
            </div >
        );
    }

    // Function to handle the selection of a radio button
    handleOrderByChange = (value) => {
        this.setState({ isOrderByResourcesValue: value }, () => {
            if (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'available' || this.state.notIssuedResource != false || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.searchMultipleAccessionNumber.length !== 0 || this.state.searchByPublisher !== '') {
                this.GetFilteredLibraryResourceList();
            } else {
                this.GetLibraryResourceListForReport();
            }
        })

    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterResourceTitle = this.state.searchByTitle
        let filterResourceAuthor = this.state.searchByAuthor
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterInvoiceNumber = this.state.searchByInvoiceNumber
        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterLocation = this.state.searchByLocation
        let filterResourceType = this.state.searchByResourceType
        let filterResourceStatus = this.state.searchByResourceStatus
        let filterIsDonated = this.state.isDonated
        let filterNotIssuedResource = this.state.notIssuedResource
        let filterAccessionNoFrom = this.state.searchAccessionNumberFrom
        let filterAccessionNoTo = this.state.searchAccessionNumberTo
        let filterPublisher = this.state.searchByPublisher.label
        let filterMultipleAccessionNo = this.state.searchMultipleAccessionNumber

        if (filterResourceTitle) {
            FilterArray.push(`Resource Title - ${filterResourceTitle}`)
        }
        if (filterResourceAuthor) {
            FilterArray.push(`Resource Author - ${filterResourceAuthor}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }
        if (this.state.searchByInvoiceNumber && filterInvoiceNumber.length > 0) {
            FilterArray.push(`Invoice Number - ${filterInvoiceNumber?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.filterLocation && filterLocation.length > 0) {
            FilterArray.push(`Location - ${filterLocation?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceStatus && filterResourceStatus.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceStatus?.map(item => item.label).join(", ")}`)
        }
        if (filterIsDonated) {
            FilterArray.push(`Donated Resources - ${this.state.isDonated ? 'Donated' : 'Not-Donated'}`)
        }
        if (filterNotIssuedResource) {
            FilterArray.push(`Not Issued Resource - ${this.state.notIssuedResource ? 'Donated' : ''}`)
        }
        if (filterAccessionNoFrom) {
            FilterArray.push(`Accession Number From - ${filterAccessionNoFrom}`)
        }
        if (filterAccessionNoTo) {
            FilterArray.push(`Accession Number To - ${filterAccessionNoTo}`)
        }
        if (filterPublisher) {
            FilterArray.push(`Publisher - ${filterPublisher}`)
        }
        if (this.state.searchMultipleAccessionNumber && filterMultipleAccessionNo.length > 0) {
            FilterArray.push(`Multiple Accession Number - ${filterMultipleAccessionNo?.map(item => item.label).join(", ")}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            {/* <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() =>
                                        this.setState({
                                            showFilterModal: !this.state.showFilterModal
                                        })
                                    }><FontAwesomeIcon size='sm' icon={["fa", "filter"]} /> Filter</button> */}

                                            <div>
                                                {/* <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}> */}
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Search by title */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Resource Title</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByTitleFilter"
                                                                    placeholder="Search by Title"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByTitle} // Bind value to state
                                                                    onChange={this.handleTitleChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceTitleKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by author */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Author</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByAuthorFilter"
                                                                    placeholder="Search by Author"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByAuthor} // Bind value to state
                                                                    onChange={this.handleFilterAuthorChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceAuthorKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based on accession series */}
                                                        {/* <div className="mb-2 p-1">
                                                        <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                            <Select
                                                                isMulti
                                                                options={this.state.accessionSeriesList}
                                                                value={this.state.searchByAccessionSeries}
                                                                className="basic-multi-select-filter"
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        pageIndex: 1, limit: "10",
                                                                        searchByAccessionSeries: event || [],
                                                                    }, () => this.GetFilteredLibraryResourceList());
                                                                }}
                                                                placeholder="Select Accession Series"
                                                                isLoading={this.state.loadingAccessionSeries}
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        width: '100%',
                                                                        minHeight: 42,
                                                                        height: 'auto',
                                                                    }),
                                                                    multiValue: (base) => ({
                                                                        ...base,
                                                                        backgroundColor: 'none',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #c4c5c5',
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                        color: '#808080',
                                                                        display: 'inline-flex',
                                                                        margin: '2px',
                                                                        whiteSpace: 'nowrap',
                                                                    }),
                                                                    multiValueContainer: (base) => ({
                                                                        ...base,
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        overflowX: 'auto',
                                                                        minHeight: 42,
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                                            />
                                                        </div>
                                                    </div> */}

                                                        {/* Based On Accession number */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Accession Number</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByAccessionNoFilter"
                                                                    placeholder="Accession Number"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByAccessionNumber}
                                                                    onChange={this.handleFilterAccessionNoChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceAccessionNoKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Invoice number */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Invoice Number</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    isMulti
                                                                    options={this.state.GetInvoiceDataList}
                                                                    value={this.state.searchByInvoiceNumber}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByInvoiceNumber: event || [], // Handle empty selection
                                                                        }, () => this.GetFilteredLibraryResourceList());
                                                                    }}
                                                                    placeholder="Select Invoice Number"
                                                                    isLoading={this.state.loadingInvoiceData} // Show loading spinner while fetching
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        multiValue: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: 'none',
                                                                            borderRadius: '5px',
                                                                            border: '1px solid #c4c5c5',
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            color: '#808080',
                                                                            display: 'inline-flex',
                                                                            margin: '2px',
                                                                            whiteSpace: 'nowrap',
                                                                        }),
                                                                        multiValueContainer: (base) => ({
                                                                            ...base,
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            overflowX: 'auto', // Horizontal scroll when values overflow
                                                                            minHeight: 42, // Ensure consistent height when values are selected
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingInvoiceData ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get Resource List As Per Accession Number Report filter result.</p>
                                                {/* </div> */}

                                                {/* {
                                                (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.searchByResourceStatus.value !== 'available' || this.state.isDonated !== false
                                                    || this.state.searchByPublisher !== '' || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.notIssuedResource !== false
                                                ) &&
                                                <div className='filter-apply'>
                                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                                </div>
                                            } */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {/* action button - order by modal */}
                                        <div className="d-flex ml-2">
                                            <button className="btn outline-button" id='orderByDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' id='orderByDropdownMenu' title="Click to Order By Report" style={{ cursor: 'pointer', color: '#0465AC' }} icon={['fas', 'sort-amount-up-alt']} /></button>

                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                                <div id='orderByDropdown'>
                                                    {
                                                        this.state.orderByResources.map((columnInfo, index) => {
                                                            // Determine if the current column is selected
                                                            const isSelected = this.state.isOrderByResourcesValue === columnInfo.value;
                                                            return (
                                                                <p className="dropdown-item" style={{
                                                                    display: 'flex', justifyContent: 'space-between', fontSize: '13px', backgroundColor: isSelected ? '#e0f7fa' : 'transparent', // Highlight background if selected
                                                                    color: isSelected ? '#0465AC' : 'black', // Change text color if selected
                                                                    cursor: 'pointer'
                                                                }} key={columnInfo.name}>
                                                                    <span
                                                                        style={{ marginRight: 10, cursor: 'pointer' }}
                                                                        onClick={() => this.handleOrderByChange(columnInfo.value)}  // Trigger the change when name is clicked
                                                                    >
                                                                        {columnInfo.name}
                                                                    </span>
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {Object.keys(this.state.resourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="resourceLisAsPerAccessionNumberReport"
                                                                    filename="ResourceListAsPerAccessionNumberReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllResourceLisAsPerAccessionNumberReport"   // export all functionality
                                                                    filename="ExportAllResourceLisAsPerAccessionNumberReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: [] }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.searchByResourceStatus.value !== 'available' || this.state.isDonated !== false
                                    || this.state.searchByPublisher !== '' || this.state.searchAccessionNumberFrom !== '' || this.state.searchAccessionNumberTo !== '' || this.state.notIssuedResource !== false
                                ) &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* filter fields */}
                        {this.state.showFilterModal &&
                            <div>
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                {/* Based On Search by title */}
                                                <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Title</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByTitleFilter"
                                                            placeholder="Title"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByTitle} // Bind value to state
                                                            onChange={this.handleTitleChange} // Handle input changes
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based On Search by author */}
                                                <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Author</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByAuthorFilter"
                                                            placeholder="Author"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByAuthor} // Bind value to state
                                                            onChange={this.handleFilterAuthorChange} // Handle input changes
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based On Accession number */}
                                                <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Accession Number</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByAccessionNoFilter"
                                                            placeholder="Accession Number"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByAccessionNumber}
                                                            onChange={this.handleFilterAccessionNoChange} // Handle input changes
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on Invoice number */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Invoice Number</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={this.state.GetInvoiceDataList}
                                                            value={this.state.searchByInvoiceNumber}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 invoice number', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByInvoiceNumber: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Invoice Number"
                                                            isLoading={this.state.loadingInvoiceData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingInvoiceData ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on accession series */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={this.state.accessionSeriesList}
                                                            value={this.state.searchByAccessionSeries}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 accession series', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByAccessionSeries: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Accession Series"
                                                            isLoading={this.state.loadingAccessionSeries} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on department */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Department</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={Object.values(this.state.GetStreamList).map(item => ({
                                                                value: item.sid,
                                                                label: item.name,
                                                            }))}
                                                            value={this.state.searchByDepartment}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 department', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByDepartment: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Department"
                                                            isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on resource category */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Resource Category</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={Object.values(this.state.GetResourceCategoryList).flatMap(item => {
                                                                // Start with the category itself
                                                                const categoryOption = {
                                                                    value: item.value,
                                                                    label: item.name,
                                                                    isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                                                };

                                                                // If the category has subcategories, add those as well
                                                                const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                                    value: subCategory.subCategoryId,
                                                                    label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                                    isDisabled: false, // Subcategory is always enabled
                                                                }));

                                                                // Return the category option followed by the subcategory options
                                                                return [categoryOption, ...subCategoryOptions];
                                                            })}
                                                            value={this.state.searchByResourceCategory}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 resource category', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByResourceCategory: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Resource Category"
                                                            isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on location */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Location</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={Object.values(this.state.GetLocationList)?.flatMap((data) => {
                                                                // Start with the parent location itself
                                                                const locationOption = {
                                                                    value: data.value,
                                                                    label: data.name,
                                                                    isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
                                                                };

                                                                // If the location has sublocations, add them as well
                                                                const subLocationOptions = data.sublocations?.map((sublocation) => ({
                                                                    value: sublocation.sublocationId,
                                                                    label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                                                                    isDisabled: false, // Subcategory is always enabled
                                                                }));

                                                                // Return the location option followed by the sublocation options
                                                                return [locationOption, ...subLocationOptions];
                                                            })}
                                                            value={this.state.searchByLocation}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 location', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByLocation: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Location"
                                                            isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on Resource Type */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Resource Type</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            isMulti
                                                            options={resourceTypeData.map((item) => ({
                                                                label: item,
                                                                value: item
                                                            }))}
                                                            value={this.state.searchByResourceType}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 resource type', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByResourceType: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Resource Type"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: 'none',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #c4c5c5',
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    color: '#808080',
                                                                    display: 'inline-flex',
                                                                    margin: '2px',
                                                                    whiteSpace: 'nowrap',
                                                                }),
                                                                multiValueContainer: (base) => ({
                                                                    ...base,
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    overflowX: 'auto', // Horizontal scroll when values overflow
                                                                    minHeight: 42, // Ensure consistent height when values are selected
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on Resource status */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Resource Status</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <Select
                                                            options={Object.values(this.state.GetResourceStatusList).map(item => ({
                                                                value: item.status,
                                                                label: item.status,
                                                            }))}
                                                            value={this.state.searchByResourceStatus}
                                                            onChange={(event) => {
                                                                // if (event.length > 5) {
                                                                //     toast.warn('You can only select up to 5 resource status', {
                                                                //         position: "top-right",
                                                                //         autoClose: 2000,
                                                                //         hideProgressBar: false,
                                                                //         closeOnClick: true,
                                                                //         pauseOnHover: true,
                                                                //         draggable: true,
                                                                //         progress: undefined,
                                                                //     });
                                                                // } else {
                                                                this.setState({
                                                                    searchByResourceStatus: event || [], // Handle empty selection
                                                                });
                                                                // }
                                                            }}
                                                            placeholder="Select Resource Status"
                                                            isLoading={this.state.loadingResourceStatusData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            noOptionsMessage={() => (this.state.loadingResourceStatusData ? "Loading..." : "No options found")}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Form Group: Only Donated Resources */}
                                                <div style={{ marginTop: '40px' }}>
                                                    <label className="vm_custom_body5" color='#454E52'>
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.isDonated}
                                                            onChange={() => {
                                                                // Toggle the value of isDonated
                                                                this.setState(prevState => ({
                                                                    pageIndex: 1,  // Resetting pageIndex to 1
                                                                    limit: "10",    // Resetting limit to 10
                                                                    isDonated: !prevState.isDonated // Toggle the isDonated state
                                                                }))
                                                            }}
                                                            style={{ marginRight: '10px' }}  // Adding space between the checkbox and text
                                                        />
                                                        Donated Resources
                                                    </label>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-md-12 d-flex justify-content-end align-items-center p-0">
                                            <div className="d-flex">
                                                <button className="print-button btn outline-button" style={{ fontSize: '14px', borderRadius: '7px' }}
                                                    onClick={() => {
                                                        this.GetFilteredLibraryResourceList();
                                                    }}
                                                >
                                                    <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style>
                                                    Apply
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {
                                    (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.searchByResourceStatus.value !== 'available' || this.state.isDonated !== false) &&
                                    <div className='filter-apply'>
                                        <p className='vm_custom_body5'>Filters are applied.</p>
                                        <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                    </div>
                                }
                            </div>
                        }

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Resource List As Per Accession Number Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceLisAsPerAccessionNumberReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="33" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="33" style={{ textAlign: 'center' }}>
                                                        Resource List As Per Accession Number Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="33" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="33" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="33" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Accession Series</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Accession Number</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Date</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Call Number</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Author</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Resource Volume</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Resource Edition</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Resource Language</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Publisher</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Publisher City</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Number of Pages</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Number of Preliminary Pages</th>}
                                                {this.state.exportItemVisibilityForRows[13].isVisible && <th>Resource Category</th>}
                                                {this.state.exportItemVisibilityForRows[14].isVisible && <th>Sub Category</th>}
                                                {this.state.exportItemVisibilityForRows[15].isVisible && <th>Year of Publication</th>}
                                                {this.state.exportItemVisibilityForRows[16].isVisible && <th>Department</th>}
                                                {this.state.exportItemVisibilityForRows[17].isVisible && <th>Resource Type</th>}
                                                {this.state.exportItemVisibilityForRows[18].isVisible && <th>Translator Name</th>}
                                                {this.state.exportItemVisibilityForRows[19].isVisible && <th>Translated</th>}
                                                {this.state.exportItemVisibilityForRows[20].isVisible && <th>Search Keyword</th>}
                                                {this.state.exportItemVisibilityForRows[21].isVisible && <th>Location</th>}
                                                {this.state.exportItemVisibilityForRows[22].isVisible && <th>ISBN Number</th>}
                                                {this.state.exportItemVisibilityForRows[23].isVisible && <th>Resource Condition</th>}
                                                {this.state.exportItemVisibilityForRows[24].isVisible && <th>Vendor Name</th>}
                                                {this.state.exportItemVisibilityForRows[25].isVisible && <th>Vendor City</th>}
                                                {this.state.exportItemVisibilityForRows[26].isVisible && <th>Vendor Country</th>}
                                                {this.state.exportItemVisibilityForRows[27].isVisible && <th>Invoice/Bill No.</th>}
                                                {this.state.exportItemVisibilityForRows[28].isVisible && <th>Invoice/Bill Date</th>}
                                                {this.state.exportItemVisibilityForRows[29].isVisible && <th>Price</th>}
                                                {this.state.exportItemVisibilityForRows[30].isVisible && <th>Discounted Amount</th>}
                                                {this.state.exportItemVisibilityForRows[31].isVisible && <th>Net Price</th>}
                                                {this.state.exportItemVisibilityForRows[32].isVisible && <th>Donated</th>}
                                                {this.state.exportItemVisibilityForRows[33].isVisible && <th>Resource Status</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.resourceListLoading ?
                                                    <tr>
                                                        <td colSpan="33">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.resourceList).length > 0 ?
                                                        (Object.values(this.state.resourceList).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.AccessionText || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.accession_date || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.callNumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.author || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.volume || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.edition || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.resource_lang || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.publisherName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.publisherCityName || ""}</td>}

                                                                    {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.number_of_pages || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.preliminary_pages || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.resourceCategoryName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.resourceSubCategories || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.yearOfPublication || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[16].isVisible && <td>{resource?.stream_name || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[17].isVisible && <td>{resource?.resource_type || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[18].isVisible && <td>{resource?.translator || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[19].isVisible && <td>{resource?.transalated || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[20].isVisible && <td>{resource?.search_key_word || ""}</td>}

                                                                    {this.state.exportItemVisibilityForRows[21].isVisible && <td>{resource?.locationName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[22].isVisible && <td>{resource?.isbn_number || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[23].isVisible && <td>{resource?.resource_condition || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[24].isVisible && <td>{resource?.vendorName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[25].isVisible && <td>{resource?.vendorCityName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[26].isVisible && <td>{resource?.vendorCountryName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[27].isVisible && <td>{resource?.billno || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[28].isVisible && <td>{resource?.billDate || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[29].isVisible && <td>{resource?.price || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[30].isVisible && <td>{((parseInt(resource?.price) * parseInt(resource?.discount)) / 100) || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[31].isVisible && <td>{(parseInt(resource?.price) - ((parseInt(resource?.price) * parseInt(resource?.discount)) / 100)) || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[32].isVisible && <td>{resource?.donated || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[33].isVisible && <td>{resource?.resource_status || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) :
                                                        <tr>
                                                            <td colSpan="33">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }

                                            {/* {
                                                // display total and grand total count
                                                Object.keys(this.state.resourceList).length > 0 ?
                                                    this.state.resourceListLoading ? null :
                                                        <>
                                                            <tr>
                                                                <td colSpan="27" style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.priceTotalCount}</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.discountTotalCount.toFixed(2)}</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.netPriceTotalCount.toFixed(2)}</td>
                                                                <td colSpan="30"></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="27" style={{ textAlign: "right", fontWeight: "bold" }}>Grand Total</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.priceTotal}</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.discountTotal}</td>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.grandTotal}</td>
                                                                <td colSpan="30"></td>
                                                            </tr>
                                                        </>
                                                    : null
                                            } */}

                                            {
                                                Object.keys(this.state.resourceList).length > 0 && !this.state.resourceListLoading &&
                                                (() => {
                                                    const visibilities = this.state.exportItemVisibilityForRows;

                                                    return (
                                                        <>
                                                            {/* Total Row */}
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                {visibilities.map((col, idx) => {
                                                                    if (!col.isVisible) return null;

                                                                    if (idx === 29) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.priceTotalCount}</td>;
                                                                    } else if (idx === 30) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.discountTotalCount.toFixed(2)}</td>;
                                                                    } else if (idx === 31) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.netPriceTotalCount.toFixed(2)}</td>;
                                                                    } else {
                                                                        return <td key={idx}></td>;
                                                                    }
                                                                })}
                                                            </tr>

                                                            {/* Grand Total Row */}
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>Grand Total</td>
                                                                {visibilities.map((col, idx) => {
                                                                    if (!col.isVisible) return null;

                                                                    if (idx === 29) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.priceTotal}</td>;
                                                                    } else if (idx === 30) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.discountTotal}</td>;
                                                                    } else if (idx === 31) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.grandTotal}</td>;
                                                                    } else {
                                                                        return <td key={idx}></td>;
                                                                    }
                                                                })}
                                                            </tr>
                                                        </>
                                                    );
                                                })()
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.resourceList).length > 0 || Object.keys(this.state.resourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            this.returnAdvanceFilterModelData()
                        }
                    </div >
                </div>
            </div >

        );
    }
}


export default ResourceListAsPerAccessionNumber;